<template>
    <!--查詢床位狀況-->
    <v-flex row wrap xs12 sm12 md12 lg12 ml-1 mr-1>

            <!--<input v-model="inputDate" style="border:1px solid black;margin-left: 10px" id="inputDate" type="date" :max="inputMaxDate" >  <v-btn @click="searchBed" middle class="pl-1 pr-1 mr-2 regFRBtn">查詢</v-btn>-->

            <v-flex class="xs12 sm12 md8 lg8 mt-2 pr-2" >
                <v-flex style="font-size: 2rem;text-align: center;font-weight: bold">{{this.bedList.zone}} {{this.bedList.zoneName}} &ensp;&ensp;&ensp;&emsp;急性一般病床使用情形  </v-flex>
                <v-flex style="font-size: 1.5rem;text-align: center">急性一般病床，總共 <span style="color: red">{{this.bedList.sumBed}}</span>  床 ( 生效日期為 &ensp;&ensp; {{this.bedList.effDate}} )  </v-flex>
                <table style="width: 100%" class="clinicTableOutline  elevation-2 ml-2 mr-2">
                    <thead class="clinicNoThead">
                    <tr>
                        <th class="clinicNoTh bed2TdBorder">病床分類: 病床數(病床比率%)</th>
                        <th class="clinicNoTh bed2TdBorder">使用床數</th>
                        <th class="clinicNoTh bed2TdBorder">空床數</th>
                        <th class="clinicNoTh bed2TdBorder">佔床率%</th>

                    </tr>
                    </thead>
                    <tbody>
                    <template>
                        <tr >
                            <td class="text-left clinicNoTd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    保險病床數:{{bedList.heBed}}  床 ({{bedList.hePer}}%)
                                </v-flex>
                            </td>
                            <td class="text-center clinicNoTd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    {{bedList.heUsedNum}}
                                </v-flex>
                            </td>
                            <td class="text-center clinicNoTd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    {{bedList.heEmptyNum}}
                                </v-flex>
                            </td>
                            <td class="text-center clinicNoTd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    {{bedList.hePerRate}}
                                </v-flex>
                            </td>


                        </tr>
                        <tr >
                            <td class="text-left clinicNoTdOdd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    收取病房費差額病床數 :  {{bedList.addBed}}  床 ({{bedList.addPer}}%)
                                </v-flex>
                            </td>
                            <td class="text-center clinicNoTdOdd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    {{bedList.addfeeUsedNum}}
                                </v-flex>
                            </td>
                            <td class="text-center clinicNoTdOdd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    {{bedList.addfeeEmptyNum}}
                                </v-flex>
                            </td>
                            <td class="text-center clinicNoTdOdd bed2TdBorder">
                                <v-flex class="clinicNoTdDiv">
                                    {{bedList.addPerRate}}
                                </v-flex>
                            </td>


                        </tr>
                    </template>



                    </tbody>

                    <tfoot class="hidetfoot" style="margin-bottom: 20px;">
                    <tr >
                        <td colspan="5" class="clinicNoTd" v-html="bedStatusOrgin"> </td>
                    </tr>
                    <tr v-if="bedStatus1!==''">
                        <td colspan="5" class="clinicNoTd" v-html="bedStatus1"> </td>
                    </tr>

                    </tfoot>
                </table>

            </v-flex>
            <v-flex class="xs12 sm12 md4 lg4 pr-3 pl-2">
                <span v-html="bedStatus2"></span>
            </v-flex>



        <v-dialog v-model="errorDialog"
                  persistent
                  :width="dialogWidth+'%'"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <alert-win @closeDialog="closeErrorDialog" @confirm="errConfirm" :alery-type="aleryType"  :alert-title="errorTitle" :alert-msg="errorContent" ></alert-win>
        </v-dialog>


        <v-dialog
                v-model="loading"
                hide-overlay
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    資料統計中，請稍後
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>

    </v-flex>

</template>

<script>
    import AlertWin from '../inursingsys/AlertWin'
    export default {
        name: "BedUsageRate",
        components:{AlertWin},
        data() {
            return {
                totalBed:'',
                effDate:'',
                inputDate:'',
                bedList:[],
                loading:false,
                errorDialog:false,
                errorTitle: '',
                errorContent:'',
                aleryType:'error',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                inputMaxDate:'',
                bedStatusOrgin:'',
                bedStatus1:'',
                bedStatus2:'',
                zoneName:'',

            }
        },
        computed:{
            dialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {return width = 100}
                if(this.$vuetify.breakpoint.sm == true){return width = 97}
                if(this.$vuetify.breakpoint.md == true){return width = 55}
                if(this.$vuetify.breakpoint.lg == true){return width = 45}
                if(this.$vuetify.breakpoint.xl ==true){return width = 40}
                return  width
            },
        },
        created(){
            let procDate = new Date();
            procDate.setDate(procDate.getDate()); //包含當天
            this.inputMaxDate = this.$UtilityJs.AD2ROC_DateTime(new Date(procDate).toISOString(), 'date');
            this.inputDate = this.inputMaxDate;
            let replaceDate = this.inputDate.replace(new RegExp("-", 'g'), "");
            let yyy = (replaceDate.substring(0,4))-1911
            let mmdd = replaceDate.substring(4,8)
            this.axios_getBedList(yyy+""+mmdd);
            this.axios_getBedStatus1();//表格內文字1
            this.axios_getBedStatus2();//表格外文字1

        },
        watch: {
            '$route.params': function () {
                let procDate = new Date();
                procDate.setDate(procDate.getDate()); //包含當天
                this.inputMaxDate = this.$UtilityJs.AD2ROC_DateTime(new Date(procDate).toISOString(), 'date');
                this.inputDate = this.inputMaxDate;
                let replaceDate = this.inputDate.replace(new RegExp("-", 'g'), "");
                let yyy = (replaceDate.substring(0,4))-1911
                let mmdd = replaceDate.substring(4,8)
                this.axios_getBedList(yyy+""+mmdd);
            },
        },
        methods:{
            searchBed(){
                let replaceDate = this.inputDate.replace(new RegExp("-", 'g'), "");
                if(replaceDate!==""){
                    let yyy = (replaceDate.substring(0,4))-1911
                    let mmdd = replaceDate.substring(4,8)
                    this.axios_getBedList(yyy+""+mmdd);
                }else {
                    alert("請輸入查詢日期")
                }

            },
            closeErrorDialog(){
                this.errorDialog = false;
            },
            errConfirm(){
                this.closeErrorDialog();
            },
            setAddfeeAmtABC(){
                let addfeeAmtA = this.bedList.addfeeAmtA==undefined?'':this.bedList.addfeeAmtA;
                let addfeeAmtB = this.bedList.addfeeAmtB==undefined?'':this.bedList.addfeeAmtB;
                let addfeeAmtC = this.bedList.addfeeAmtC==undefined?'':this.bedList.addfeeAmtC;
                this.bedStatusOrgin = '收取病房費差額 <br>'+
                    '<span>&emsp; &emsp;&emsp; &emsp; '+'<span style="color: red">'+addfeeAmtA+'</span>&nbsp;元</span><br>'+
                    '<span>&emsp; &emsp;&emsp; &emsp; '+'<span style="color: red">'+addfeeAmtB+'</span>&nbsp;元</span><br>'+
                    '<span>&emsp; &emsp;&emsp; &emsp; '+'<span style="color: red">'+addfeeAmtC+'</span>&nbsp;元</span><br>';
            },
            axios_getBedList(sDate){
                this.bedList  =[];
                this.loading = true;
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let startDate = sDate;
                let url = this.$store.state.AppSetting.backSrvUrl+'emgdaybed/datasearch/maxeffdatezone/'+startDate+"/"+zone

                this.$http.get(url).then(response=>{

                    // this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
                        this.bedList  = response.data.resultSet[0];
                        this.setAddfeeAmtABC();
                        this.loading = false;
                    }else if(response.data.resultSet.length==0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
                        this.bedList  =[];
                        this.errorDialog = true;
                        this.errorTitle = "訊息";
                        this.errorContent = '<div style="color: red">'+response.data.message+'</div>';
                        this.loading = false;
                        this.setAddfeeAmtABC();
                    }else {
                        this.bedList  =[];
                        this.errorDialog = true;
                        this.errorTitle = "訊息";
                        this.errorContent = '<div style="color: red">'+ response.data.message+'</div>';
                        this.snStatus=true;
                        this.snText = response.data.message;
                        this.loading = false;
                        this.setAddfeeAmtABC();
                    }

                }).catch(error =>{
                    this.bedList  =[];
                    this.loading = false;
                    this.setAddfeeAmtABC();
                    try {
                        let errorMsg = error.response.data.message==undefined?error.response.data.status:error.response.data.message;
                        switch (error.response.status){
                            case 300:
                            case 400:
                            case 401:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent = '<div style="color: red;font-size: 1.2rem;font-weight: bold">'+ errorMsg+'</div>';
                                break;
                            case 404:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent ="找不到頁面";
                                break;
                            case 500:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent = "伺服器錯誤";
                                break;
                            default:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent ='<div style="color: red;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
                        }

                    } catch(err) {
                        console.log(err.response.data.message)
                    }
                });
            },

            axios_getBedStatus1 (){ //表格內說明文字1 BEDSTATUS1
                this.bedStatus1 = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/BEDSTATUS1/ALLCODE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.bedStatus1+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.bedStatus1 = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.bedStatus1 = '';
                    } catch(err) {
                        this.bedStatus1 = '';
                    }
                });
            },

            axios_getBedStatus2 (){ //表格外說明文字2 BEDSTATUS2
                this.bedStatus2 = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/BEDSTATUS2/ALLCODE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.bedStatus2+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.bedStatus2 = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.bedStatus2 = '';
                    } catch(err) {
                        this.bedStatus2 = '';
                    }
                });
            },
        }
    }
</script>

<style scoped>


</style>